module.exports = __webpack_public_path__ + "static/media/icon_calendar.d2d033be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_calendar.svg
// module id = 706
// module chunks = 0